import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { MainAdminTables, AddModalWriters, DeleteModalWriters } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import { Link, useLocation } from "react-router-dom"; 
import MainAdminUsersExamTables from "../../components/MainAdmin/Table/MainAdminUsersExamTables";
import DeleteModalUsersExam from "../../components/MainAdmin/Modals/DeleteModalUsersExam";
import AddModalUserInExam from "../../components/MainAdmin/Modals/AddModalUserInExam";

const MainAdminUsersExam = () => {
      const location = useLocation();


    const titleRow = ["نام", "نام خانوادگی", "کدملی", "ادمین", "نام کاربری", "رمز عبور"];
    const adminList =["علی","احمدی","0020163258","09120760563","A1324","A"]
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
            const [users, setUsers] = useState();
    
    const itemsPerPage = 10;
      let navigate = useNavigate();

       const GetData = async () => {
            const writersData = await axiosReq("exam/GetUsersByExam?page=" + page + "&&pageSize=" + row + "&&search=" + search, "post",{
                ExamId:location.state.id
            });
            console.log(writersData)
            // setWritersList(writersData?.data)
            // setCount(writersData?.count)
              setWritersList(writersData?.data)
             setCount(writersData?.count)
        }
          const auth = async () => {
                        const cookies = new Cookies();
                        var token = cookies.get('token');
                        console.log(token)
                        console.log(cookies.get('role'))
                        if (!token) {
                            navigate("/");
                        } 
                        else {
                        //     if( cookies.get('role')=="Admin")
                        //    {
                
                               GetData()
                               GetUsers()
                        //    }
                
                            
                        //     else {
                        //         navigate("/admin");
                
                        //     }
                        }
                    }
        useEffect(() => {
    
            auth();
        }, [reCheck,search,page, row,]);

   const GetUsers = async () => {
       try {
           const writersData = await axiosReq("user/GetUsers", "get");
           console.log(writersData);
           var type=[]
           writersData.map((item)=>{
   type.push({label:item.name+" "+item.family,value:item.userId})
           })
           setUsers(type);
         
           
       } catch (error) {
           console.error("Error fetching data:", error);
         
       }
   };
    // const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]"> کاربران گزینش</p>
                </div>
                <div className="flex justify-start items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e)=>setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div>
                    {/* <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button>*/}
                    <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن کاربر</p>
                    </button> 
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminUsersExamTables detail={true} edit={false} gozinesh={false} block={false} deleted={true} setting={false}
                    setShowEditModal={setShowEditModal} setShowBlockModal={setShowBlockModal} 
                    setShowDeleteModal={setShowDeleteModal}
                    data={data} setData={setData}
                    setShowSettingModal={setShowSettingModal}
                    titleRow={titleRow} writersList={writersList} 
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} /></div>


            {showAddModal ? <AddModalUserInExam title={'افزودن کاربر جدید'} buttonName={'ثبت'} ExamId={location.state.id} setShowModal={setShowAddModal} reCheck={reCheck} users={users} setRecheck={setRecheck} setSettingModal={setShowSettingModal}setData={setData} /> : null}
            {/* {showEditModal ? <AddModalAdmin title={'ویرایش'} buttonName={'ویرایش'} setShowModal={setShowEditModal} data={data} reCheck={reCheck} setRecheck={setRecheck} /> : null} */}
            {showDeleteModal ? <DeleteModalUsersExam title={'حذف کاربر'} buttonName={'حذف'} text={'آیا از حذف کاربر انتخاب شده اطمینان دارید ؟'} setShowModal={setShowDeleteModal} data={data} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {showSettingModal ? <SettingModal title={'مدیریت دسترسی'} buttonName={'ثبت'} setShowModal={setShowSettingModal} reCheck={reCheck} setRecheck={setRecheck} data={data} /> : null}
           
        </div>
    )
}

export default MainAdminUsersExam;